// extracted by mini-css-extract-plugin
export var black = "_2d-6";
export var brand = "_2d-1";
export var ddefault = "_2d-0";
export var error = "_2d-3";
export var gray = "_2d-2";
export var highContrast = "_2d-8";
export var outline = "_2d-7";
export var success = "_2d-5";
export var warning = "_2d-4";